/** Stable error codes returned by the API. Clients translate them; messages are for logs only. */
export const ERROR_CODES = [
  'unauthenticated',
  'forbidden',
  'not_found',
  'validation_failed',
  'rate_limited',
  'credentials_invalid',
  'account_disabled',
  'login_taken',
  'invitation_invalid',
  'invite_invalid',
  'screening_ended',
  'participant_banned',
  'admission_pending',
  'admission_denied',
  'admission_decision_conflict',
  'playback_version_conflict',
  'asset_not_ready',
  'asset_in_use',
  'track_not_deletable',
  'upload_too_large',
  'unsupported_subtitle_format',
  'unsupported_image_format',
  'realtime_unavailable',
  'internal',
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

/** HTTP status for each code, so every route answers the same way. */
export const ERROR_HTTP_STATUS = {
  unauthenticated: 401,
  forbidden: 403,
  not_found: 404,
  validation_failed: 400,
  rate_limited: 429,
  credentials_invalid: 401,
  account_disabled: 403,
  login_taken: 409,
  invitation_invalid: 404,
  invite_invalid: 404,
  screening_ended: 410,
  participant_banned: 403,
  admission_pending: 403,
  admission_denied: 403,
  admission_decision_conflict: 409,
  playback_version_conflict: 409,
  asset_not_ready: 409,
  asset_in_use: 409,
  track_not_deletable: 409,
  upload_too_large: 413,
  unsupported_subtitle_format: 415,
  unsupported_image_format: 415,
  realtime_unavailable: 503,
  internal: 500,
} as const satisfies Record<ErrorCode, number>;
